export default __webpack_public_path__ + "static/media/Main_Roadmap_Img_2_440px.507e6332.png";